import $ from 'jquery'
import { Alert } from '../functions'

// eslint-disable-next-line no-undef
const object = vnObject

const form = $('.contact-form')

if (form.length) {
  form.parsley().on('form:success', function () {
    form.attr('data-success', 'true')
  })

  form.parsley().on('form:error', function () {
    form.attr('data-success', 'false')
  })

  form.on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $form = $(this)

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: $form.serialize() + '&action=' + 'vn_contact',
      beforeSend: () => {
        $form.addClass('sending')
        Alert('warning', object.formWait, false)
      },
      success: (res) => {
        $form.removeClass('sending')

        if (res.success && res.data.redirect) {
          window.location = res.data.redirect
        }

        Alert(res.success, res.data.message)
        res.success && $form[0].reset()
      },
    })
  })
}

var trainingTypesSelectize = $('#training_types').selectize({
  preload: true,
  valueField: 'value',
  labelField: 'title',
  searchField: 'title',
  plugins: ['remove_button'],
  delimiter: '+',
  options: [
    { value: 'diploma_trainings', title: object.diplomaName },
    { value: 'continuing_trainings', title: object.continuingName },
    { value: 'region_trainings', title: object.regionName },
  ],
  onInitialize: function(){
    var selectize = this;
    var selected_items = [];
    selectize.setValue(selected_items);
  },
  onDropdownOpen: function(){
    roomSelectize[0].selectize.close()
    realtySelectize[0].selectize.close()
  },
});

var trainingCentersSelectize = $('#training_centers').selectize({
  preload: true,
  valueField: 'id',
  labelField: 'title',
  searchField: 'title',
  plugins: ['remove_button'],
  delimiter: '+',
  load: function(query, callback) {
    $.ajax({
      url: object.ajaxUrl,
      data: { action: 'vn_autocomplete_training_centers', q: encodeURIComponent(query) },
      type: 'GET',
      error: function() {
        callback();
      },
      success: function(res) {
        callback(res.data.slice(0, 10));
      }
    });
  },
  onInitialize: function(){
    var selectize = this;
    var selected_items = [];
    selectize.setValue(selected_items);
  },
  onDropdownOpen: function(){
    roomSelectize[0].selectize.close()
    realtySelectize[0].selectize.close()
  },
});
